import { render, staticRenderFns } from "./TeamShiftRotaList.vue?vue&type=template&id=477abe28&"
import script from "./TeamShiftRotaList.vue?vue&type=script&lang=js&"
export * from "./TeamShiftRotaList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports